import { defineStore } from "pinia";
import { ref, reactive, watch } from "vue";
import DashboardService from "@/services/dashboard.service";
import { usePeriodeStore } from "./periode.store";

export const useDashboardStore = defineStore("dashboard", () => {
  const loading    = ref(false);
  const meta       = ref<any>(null);
  const kpis       = ref<any>(null);
  const graphiques = ref<any>(null);
  const recents    = ref<any>(null);
  const alertes    = ref<any[]>([]);

  const filtres = reactive({
    // Filtres géographiques
    region_id:      null as number | null,
    departement_id: null as number | null,
    commune_id:     null as number | null,
    haras_id:       null as number | null,
    naisseur_id:    null as number | null,
  });

  // Raccourcis vers le store période (pour que FiltresDashboard.vue continue de fonctionner)
  const periodeStore = usePeriodeStore();
  const filtresTemporels = periodeStore;

  async function charger() {
    loading.value = true;
    try {
      const params: Record<string, any> = { ...periodeStore.params };

      // Filtres géographiques
      if (filtres.region_id)      params.region_id      = filtres.region_id;
      if (filtres.departement_id) params.departement_id = filtres.departement_id;
      if (filtres.commune_id)     params.commune_id     = filtres.commune_id;
      if (filtres.haras_id)       params.haras_id       = filtres.haras_id;
      if (filtres.naisseur_id)    params.naisseur_id    = filtres.naisseur_id;

      const res = await DashboardService.get(params);
      meta.value       = res.meta       ?? null;
      kpis.value       = res.kpis       ?? null;
      graphiques.value = res.graphiques ?? null;
      recents.value    = res.recents    ?? null;
      alertes.value    = res.alertes    ?? [];
    } catch (e) {
      console.error("Dashboard store:", e);
    } finally {
      loading.value = false;
    }
  }

  // Recharger automatiquement quand la période change
  watch(() => periodeStore.params, () => charger(), { deep: true });

  return { loading, meta, kpis, graphiques, recents, alertes, filtres, filtresTemporels, charger };
});
